import axios from "axios";
import { APIURL } from "./config";
import {
  CUSTOMERS_LIST,
  CUSTOMERS_ADD,
  CUSTOMERS_UPDATE,
  CUSTOMERS_DELETE,
  LOADING,
  NOT_FOUND,
} from "./type";
import { toast } from "react-toastify";

export const customersList =
  (params = {}) =>
  async (dispatch) => {
    dispatch({
      type: LOADING,
      payload: "",
    });
    const token = localStorage.getItem("token");
    // Filter out empty parameters
    const cleanParams = Object.entries(params).reduce((acc, [key, value]) => {
      if (value !== "" && value !== null && value !== undefined) {
        acc[key] = value;
      }
      return acc;
    }, {});

    var config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params: cleanParams,
    };
    try {
      const res = await axios.get(`${APIURL}/api/v1/users`, config);
      const responseData = res?.data;
      const payload = responseData?.data || responseData;
      let normalizedPayload = {};

      if (Array.isArray(payload)) {
        normalizedPayload = { docs: payload };
      } else if (payload?.users) {
        // Extract pagination from sibling 'pagination' object or fallback to internal properties
        const pagination = responseData?.pagination || {};
        normalizedPayload = {
          docs: payload.users,
          totalDocs:
            pagination.total ||
            payload.totalDocs ||
            payload.count ||
            payload.users.length,
          totalPages: pagination.totalPages || payload.totalPages || 1,
          page: pagination.page || payload.page || 1,
          limit: pagination.limit || payload.limit || 10,
        };
      } else {
        normalizedPayload = payload;
      }

      dispatch({
        type: CUSTOMERS_LIST,
        payload: normalizedPayload,
      });

      if (normalizedPayload.docs?.length === 0) {
        dispatch({
          type: NOT_FOUND,
          payload: "",
        });
      }
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message || "Error fetching customers");
    }
  };
export const addCustomers = (val) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  const body = JSON.stringify({
    firstName: val?.firstName,
    middleName: val?.middleName,
    lastName: val?.lastName,
    phone: val?.mobile,
    alternative_phone: val?.alternative_phone,
    cell: val?.cell,
    home: val?.home,
    email: val?.email,
    sendEmail: true,
    password: val?.password,
    customerNotes: val?.customerNotes,
    // city: val?.city,
    image: val.image == "undefined" ? "" : val.image,
    status: val.status,
    position: "user_customer",
  });
  try {
    const response = await axios.post(`${APIURL}/api/v1/users`, body, config);
    dispatch({ type: CUSTOMERS_ADD, payload: response?.data });
    toast.success("Customer Created Successfully!");
    setTimeout(() => {
      return (window.location.href = "/manage-customers");
    }, 1000);
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};
export const updateCustomers = (val, id) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  const body = JSON.stringify({
    firstName: val?.firstName,
    middleName: val?.middleName,
    lastName: val?.lastName,
    phone: val?.phone,
    alternative_phone: val?.alternative_phone,
    cell: val?.cell,
    home: val?.home,
    email: val?.email,
    sendEmail: true,
    password: val?.password,
    // city: val?.city,
    customerNotes: val?.customerNotes,
    image: val.image == "undefined" ? "" : val.image,
    position: "user_customer",
    subscriptionCanceled: val?.subscrptStatus,
  });
  try {
    const response = await axios.patch(
      `${APIURL}/api/v1/users/${id}`,
      body,
      config
    );
    dispatch({ type: CUSTOMERS_UPDATE, payload: response?.data });
    toast.success("Customer Updated Successfully!");
    setTimeout(() => {
      return (window.location.href = "/manage-customers");
    }, 1000);
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

export const CustomerDelete = (id) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    isDeleted: true,
  });

  var requestOptions = {
    method: "PATCH",
    headers: myHeaders,
    body: raw,
    redirect: "manual",
  };

  if (window.confirm("Do you want to delete customer?")) {
    const res = await fetch(
      `${APIURL}/api/v1/users/deleteUsers/${id}`,
      requestOptions
    )
      .then((response) => response.json())
      .catch((error) => console.log("error", error));
    if (res?.status == "success") {
      toast.success("Customer Deleted Successfully!");
    }
    return { res };
  }
};

export const updateVehicle = (val, id, vehId) => async (dispatch) => {
  const token = localStorage.getItem("token");

  var myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    name: val.name,
    model: val.model,
    color: val.color,
    reg_no: val.reg_no,
    type: val.type,
    year: val.year,
    _id: vehId,
  });

  var requestOptions = {
    method: "PATCH",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  fetch(`${APIURL}/api/v1/users/updateUserVehicle/${id}`, requestOptions)
    .then((response) => response.json())
    .then((result) => {
      if (result.status == "success") {
        toast.success("Vehicle Updated Successfully!");
        setTimeout(() => {
          return (window.location.href = `/edit-customers/${id}`);
        }, 1000);
      }
    })
    .catch((error) => console.log("error", error));
};

export const addVehicle = (val, id) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  const body = JSON.stringify({
    year: val.year,
    name: val.name,
    model: val.model,
    color: val.color,
    reg_no: val.reg_no,
    type: val.type,
    _id: val._id,
  });
  try {
    const response = await axios.patch(
      `${APIURL}/api/v1/users/updateUserVehicle/${id}`,
      body,
      config
    );
    toast.success("Vehicle added Successfully!");
    setTimeout(() => {
      return (window.location.href = `/edit-customers/${id}`);
    }, 1000);
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};
export const VehicleDelete = (id, vehID) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${token}`);
  var raw = JSON.stringify({
    vehicleId: vehID,
  });

  var requestOptions = {
    method: "PATCH",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  if (window.confirm("Do you want to delete vehicle??")) {
    fetch(`${APIURL}/api/v1/users/deleteUserVehicle/${id}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result?.status == "success") {
          toast.success("Vehicle Deleted Successfully!");
        }
      })
      .catch((error) => console.log("error", error));
  }
};
export const addAddress = (val, id) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  const body = JSON.stringify({
    street_no: val.street,
    address: val.address,
    city: val.city,
    lat: val.lat,
    long: val.lon,
    type: "Other",
  });

  try {
    const response = await axios.patch(
      `${APIURL}/api/v1/users/addUserAddress/${id}`,
      body,
      config
    );
    toast.success("Address added Successfully!");
    setTimeout(() => {
      return (window.location.href = `/edit-customers/${id}`);
    }, 1000);
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

export const updateAddress = (val, id, addId) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");
  var raw = JSON.stringify({
    street_no: val.street,
    address: val.address,
    city: val.city,
    lat: val.lat,
    long: val.lon,
    _id: addId,
  });
  var requestOptions = {
    method: "PATCH",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  fetch(`${APIURL}/api/v1/users/updateUserAddress/${id}`, requestOptions)
    .then((response) => response.json())
    .then((result) => {
      if (result.status == "success") {
        toast.success("Address updated Successfully!");
        setTimeout(() => {
          return (window.location.href = `/edit-customers/${id}`);
        }, 1000);
      }
    })
    .catch((error) => console.log("error", error));
};
export const AddressDelete = (id, addID) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${token}`);
  var raw = JSON.stringify({
    addressId: addID,
  });

  var requestOptions = {
    method: "PATCH",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  if (window.confirm("Do you want to delete address?")) {
    fetch(`${APIURL}/api/v1/users/deleteUserAddress/${id}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result?.status == "success") {
          toast.success("Address Deleted Successfully!");
        }
      })
      .catch((error) => console.log("error", error));
  }
};

export const multiCustomerDelete = (id) => {
  const token = localStorage.getItem("token");
  var myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    isDeleted: true,
  });

  var requestOptions = {
    method: "PATCH",
    headers: myHeaders,
    body: raw,
    redirect: "manual",
  };

  const label = id?.length > 1 ? "Customers" : "Customer";
  if (window.confirm(`Do you want to delete the selected ${label.toLowerCase()}?`)) {
    fetch(`${APIURL}/api/v1/users/multiUser/${id}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result?.status == "success") {
          toast.success(`${label} Deleted Successfully!`);
        }
      })
      .catch((error) => console.log("error", error));
  }
};

export const editPasswordCustomer = (payload, callBack) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    password: payload.password,
  });

  var requestOptions = {
    method: "PATCH",
    headers: myHeaders,
    body: raw,
    redirect: "manual",
  };

  if (window.confirm("Do you want to edit Customer password?")) {
    fetch(`${APIURL}/api/v1/users/resetPassword/${payload?.id}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result?.status == "success") {
          callBack("success");
          toast.success("Password updated Successfully!");
        }
      })
      .catch((error) => {
        callBack("error");
        console.log("error", error);
      });
  }
};

// cancel recurring

export const cancelRecurring = async (payload, callBack) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  const body = JSON.stringify({
    targetUserId: payload?.userId,
  });

  try {
    const response = await axios.post(
      `${APIURL}/api/v1/payments/cancel-subscription`,
      body,
      config
    );
    if (response?.data?.message === "success") {
      // Set when the subscription is in the previous Stripe account - it
      // still has to be cancelled there.
      const warning = response?.data?.result?.warning;
      if (warning) toast.warning(warning, { autoClose: false });
      callBack("success");
    }
  } catch (error) {
    toast.error(error?.response?.data?.message || "Please try again!");
  }
};
